import { getErrorMessageFromErrorType } from '@flowwai-frontend/shared/utils/common'

import { GetEntityJsonConfigurationQuery as Query } from './query.generatedTypes'

interface ArgsTypes {
   data: Query
   onSuccess?: (jsonData: string) => void
   onFailure?: (
      errorMessage: string,
      data: Query['getEntityJsonConfiguration']
   ) => void
}

const useResponseHandler = () => {
   const handleAPIResponse = (args: ArgsTypes) => {
      const { data, onSuccess, onFailure } = args

      const responseData = data.getEntityJsonConfiguration

      switch (responseData.__typename) {
         case 'GetEntityJsonConfigurationResult': {
            if (responseData.jsonConfiguration) {
               onSuccess?.(responseData.jsonConfiguration.jsonData)
            }
            break
         }
         case 'EntityJsonConfigurationDoesNotExists':
         default: {
            const errorType = responseData.__typename
            const errorMessage = getErrorMessageFromErrorType(errorType)

            onFailure?.(errorMessage, responseData)
         }
      }
   }

   return { handleAPIResponse }
}

export default useResponseHandler
